import { routerKeys } from '~shared/router';
import { ToolbarBtn } from '~shared/ui';

import { SectionList } from './SectionList/SectionList';

export function ListPage() {
	return (
		<div className="sections" style={{ height: '100%' }}>
			<h1 className="mb-2">Список участков</h1>
			<SectionList />
			<ToolbarBtn to={routerKeys.cabinet.admin.sections.section('add')} title="Создать" icon1="plus_white" />
		</div>
	);
}
